export const NAV_LIST = [
  {
    name: "首页",
    path: "/home",
    children: [],
  }, {
    name: "公司介绍",
    path: "/companyintroduction",
    children: [],
  },
  {
    name: "产品与解决方案",
    path: "/software",
    children: [
      {
        name: "医疗健康",
        path: "/software/software1",
        subItems: [
          {
            name: "智慧医院智能导诊系统",
            path: "/software/software1",
          },
          {
            name: "智慧医院便民服务系统",
            path: "/software/software2",
          },{
            name: "智慧医院医护管理系统",
            path: "/software/software3",
          },{ 
            name: "智慧医院在线问诊系统", 
            path: "/software/software4" 
          }, 
          {
            name: "智慧医院健康管理系统",
            path: "/software/software5",
          },{
            name: "智慧医院居家护理系统",
            path: "/software/software6",
          }
          ,{
            name: "就医服务投诉管理系统",
            path: "/software/software11",
          },{
            name: "就医服务满意度管理系统",
            path: "/software/software12",
          },{
            name: "数字医工医疗设备管理系统",
            path: "/software/software13",
          },{
            name: "数字医工医疗设备运营系统",
            path: "/software/software15",
          },
          
        ],
      },
      {
        name: "电子政务",
        path: "/software/softwareWs1",
        subItems: [{
            name: "全员人口信息管理系统",
            path: "/software/softwareWs1",
          },{
            name: "生育服务登记管理系统",
            path: "/software/softwareWs2",
          },{
            name: "电子死亡证明管理系统",
            path: "/software/softwareWs3",
          },{
            name: "农村厕所革命信息系统",
            path: "/software/softwareWs4",
          },{
            name: "疾控智慧实验室管理系统",
            path: "/software/softwareWs6",
          }, {
            name: "应急物资动态管理系统",
            path: "/software/softwareWs7",
          }, {
            name: "传染病智能流调系统",
            path: "/software/softwareWs8",
          },{
            name: "全域旅游智慧系统",
            path: "/software/softwareWs10",
          },{
            name: "互联网舆情管理系统",
            path: "/software/softwareWs11",
          }, {
            name: "重大事故隐患排查整治系统",
            path: "/software/softwareWs9",
          }
        ],
      }, {
        name: "数字企业",
        path: "/software/softwareWs16",
        subItems: [
          {
            name: "充换电一张网服务平台",
            path: "/software/softwareWs16",
          },
          // {
          //   name: "新质餐厅智能识别支付系统",
          //   path: "/software/softwareWs13",
          // },
          {
            name: "新质企业智能问数系统",
            path: "/software/softwareWs14",
          }, {
            name: "免税品离岛提货跟踪服务系统",
            path: "/software/softwareWs15",
          }
        ],
      },
    ],
  },
  // {
  //   name: "解决方案",
  //   path: "/Solution",
  //   children: [
  //     {
  //       name: "智慧医疗",
  //       path: "/Solution/Solution1",
  //       subItems: [
  //         { name: "(医疗新质服务)互联网+医疗数据服务运营解决方案", path: "/Solution/Solution1" },
  //         { name: "(芯医工)医疗设备全生命周期管理解决方案", path: "/Solution/Solution3" },
  //         { name: "资产精准盘点清查解决方案", path: "/Solution/Solution4" },
  //       ],
  //     }, {
  //       name: "公共卫生",
  //       path: "/Solution/Solution6",
  //       subItems: [
  //         { name: "区域传染病监测预警与应急指挥信息解决方案", path: "/Solution/Solution6" },
  //       ],
  //     },
  //     {
  //       name: "数字卫健",
  //       path: "/Solution/Solution8",
  //       subItems: [
  //         { name: "政务信息资源体系全员人口库解决方案", path: "/Solution/Solution8" },
  //         { name: "紧密型县域医共体解决方案", path: "/Solution/Solution9" },
  //       ],
  //     },
  //     {
  //       name: "大型企业",
  //       path: "/Solution/Solution10",
  //       subItems: [
  //         { name: "全链条物流、仓储管理解决方案", path: "/Solution/Solution10" },
  //         { name: "停充一体化监管与服务解决方案", path: "/Solution/Solution12" },
  //       ],
  //     },
  //   ],
  // },
  {
    name: "公司优势",
    path: "/advantage",
    children: [],
  },
  {
    name: "荣誉资质",
    path: "/newsinformation",
    children: [],
  },
  {
    name: "公司动态",
    path: "/myDevelop",
    children: [],
  },
  {
    name: "联系我们",
    path: "/contactus",
    children: [],
  },
]


// WEBPACK FOOTER //
// ./src/components/components/navConfig.js